import styled from "styled-components";

export const Container = styled.div`
  width: calc(100% - 2rem);
  height: 100%;
  margin: auto;
  border-radius: 24px;
  background: #fff;
  padding: 0 1rem;
  ${(props) =>
    props?.isDNDTool &&
    `
.info-container-extra .info-container {
    width:15% !important;
    }
  `}
  .standing-chart-header {
    .title {
      font-weight: 700;
    }
  }
  .info-container-extra {
    border-top: 4px solid rgb(126, 126, 126);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .info-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 49%;
      height: 70%;
      margin: 1rem 0;
      text-align: center;
      .title {
        margin: 0;
      }
      .subtext {
        color: #ff6a00;
        font-weight: 700;
        margin: 0;
      }
      h3 {
        margin: 0;
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .info-container-extra .info-container {
      width: 15%;
    }
  }
`;
